import React from 'react';
import { Box, Typography, Button, alpha, useTheme } from '@mui/material';
import { Inbox } from 'lucide-react';

export default function EmptyState({
  icon: Icon = Inbox,
  title = 'No records found',
  description = 'Try adjusting your search or filter to find what you are looking for.',
  actionLabel,
  onAction,
  action,
  sx = {},
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        px: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          color: theme.palette.primary.main,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <Icon size={28} strokeWidth={1.75} />
      </Box>

      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          color: 'text.primary',
          mb: 0.5,
          fontSize: '1rem',
        }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            maxWidth: 420,
            mb: actionLabel || action ? 2.5 : 0,
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      )}

      {action ? (
        action
      ) : actionLabel && onAction ? (
        <Button
          variant="contained"
          size="small"
          onClick={onAction}
          sx={{ mt: 1 }}
        >
          {actionLabel}
        </Button>
      ) : null}
    </Box>
  );
}
